<template>
  <div class="page-wrap staff-manage">
    <page-header :title="$route.meta.title">
      <template>
        <div
          class="page-header-handle-wrap"
          v-if="handleRightsList.includes('添加')"
        >
          <a-dropdown class="handle-title">
            <div class="page-header-handle-item">
              <!-- <img
                class="handle-icon"
                src="../../assets/img/icon/新增账户.png"
              /> -->
              <span> {{ $t('week.addWeek') }} <a-icon type="down" /> </span>
            </div>

            <a-menu slot="overlay">
              <a-menu-item @click="handleAdd">
                {{ $t('week.addWeek') }}
              </a-menu-item>
              <!-- <a-menu-item>批量导入</a-menu-item> -->
            </a-menu>
          </a-dropdown>
        </div>

        <div class="page-header-handle-wrap">
          <div
            v-for="(item, index) in categoryRouterList"
            :key="index"
            class="page-header-handle-item"
            :class="{
              'active-handle': $route.name === item.name
            }"
            @click="handleTap(item)"
          >
            <img
              class="handle-icon"
              :src="item.meta.icon"
              :alt="item.meta.title"
            />
            <div class="handle-title">{{ $t(item.meta.title) }}</div>
          </div>
        </div>
      </template>
    </page-header>

    <transition name="default" mode="out-in">
      <router-view
        @child-edit="btnEdit"
        :key="$route.path + updateComponent"
      ></router-view>
    </transition>

    <a-modal
      :title="modelName"
      v-model="modalVisible"
      :confirmLoading="modalLoading"
      :afterClose="afterClose"
      @ok="ok"
    >
      <a-form
        labelAlign="left"
        :form="form"
        layout="vertical"
        :labelCol="{ span: 24 }"
        :wrapperCol="{ span: 24 }"
      >
        <a-form-item :label="$t('week.weekName')">
          <a-input
            :placeholder="$t('week.weekName')"
            v-decorator="[
              'weeks',
              {
                rules: [
                  {
                    required: true,
                    message: $t('week.pleaseFill') + $t('week.weekName')
                  }
                ]
              }
            ]"
          >
          </a-input>
        </a-form-item>
        <a-form-item :label="$t('week.schoolYear')">
          <a-select
            :placeholder="$t('week.schoolYear')"
            v-decorator="[
              'academic',
              {
                rules: [
                  {
                    required: true,
                    message: $t('week.pleaseFill') + $t('week.schoolYear')
                  }
                ]
              }
            ]"
          >
            <a-select-option
              v-for="(item, index) in academicYearList"
              :key="index"
              :value="item"
            >
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('week.semester')">
          <a-select
            :placeholder="$t('week.semester')"
            v-decorator="[
              'semester',
              {
                rules: [
                  {
                    required: true,
                    message: $t('week.pleaseFill') + $t('week.semester')
                  }
                ]
              }
            ]"
          >
            <a-select-option
              v-for="(item, index) in semesterList"
              :key="index"
              :value="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('week.startName')">
          <a-date-picker
            :placeholder="$t('week.startName')"
            style="width:100%"
            v-decorator="[
              'startTime',
              {
                rules: [
                  {
                    required: true,
                    message: $t('week.pleaseFill') + $t('week.startName')
                  }
                ]
              }
            ]"
          />
        </a-form-item>
        <a-form-item :label="$t('week.endDate')">
          <a-date-picker
            :placeholder="$t('week.pleaseFill') + $t('week.endDate')"
            style="width:100%"
            v-decorator="[
              'endTime',
              {
                rules: [
                  {
                    required: true,
                    message: $t('week.pleaseFill') + $t('week.endDate')
                  }
                ]
              }
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import PageHeader from '../../components/PageHeader.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  components: {
    PageHeader
  },

  data() {
    return {
      updateComponent: new Date().getTime(),
      modelName: null,
      // 部门
      departmentOptions: [],

      campusList: [],
      modalVisible: false,
      modalLoading: false,
      form: this.$form.createForm(this),
      operationFlag: null,
      editId: null
    }
  },

  computed: {
    ...mapGetters([
      'categoryRouterList',
      'handleRightsList',
      'academicYearList',
      'semesterList'
    ])
  },

  created() {
    this.getAllDepartment()
  },

  methods: {
    btnEdit(val) {
      this.modelName = this.$t('week.edit') + this.$t('week.weekName')
      this.modalVisible = true
      this.operationFlag = 1
      this.editId = val.id
      this.$nextTick(() => {
        this.form.setFieldsValue({
          semester: val.semester,
          weeks: val.weeks,
          startTime: moment(val.startTime),
          endTime: moment(val.endTime),
          academic: val.academic
        })
      })
    },
    // 搜索选项
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },

    // 所有部门
    async getAllDepartment() {
      return new Promise((resolve, reject) => {
        this.$http(this.$api.GETROLELISTALL)
          .then(r => {
            this.departmentOptions = r.data
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },

    handleAdd() {
      this.modelName = this.$t('week.addWeek')
      this.operationFlag = 2
      this.getAllCampus()
      this.modalVisible = true
    },

    // 所有校区
    getAllCampus() {
      this.$http(this.$api.GETLISTALLCAMPUS).then(r => {
        this.campusList = r.data
      })
    },
    handEdit(values) {
      values.id = this.editId
      values.startTime = moment(values.startTime).format('YYYY-MM-DD')
      values.endTime = moment(values.endTime).format('YYYY-MM-DD')
      this.$http(this.$api.UPDATEWEEK, values)
        .then(() => {
          this.$message.success(this.$t('public.saveSuccess'))
          this.modalVisible = false
          this.updateComponent = new Date().getTime()
        })
        .catch(() => {
          this.modalLoading = false
        })
    },
    // 提交
    ok() {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.operationFlag == 1) {
            this.handEdit(values)
          } else {
            this.handleSave(values)
          }
        }
      })
    },

    handleSave(values) {
      this.modalLoading = true
      values.startTime = moment(values.startTime).format('YYYY-MM-DD')
      values.endTime = moment(values.endTime).format('YYYY-MM-DD')
      this.$http(this.$api.addWeek, values)
        .then(() => {
          this.modalVisible = false
          this.$message.success(this.$t('public.saveSuccess'))
          this.updateComponent = new Date().getTime()
        })
        .catch(() => {
          this.modalLoading = false
        })
    },

    afterClose() {
      this.form.resetFields()
      this.modalLoading = false
    },

    handleTap(component) {
      this.$router.push({
        name: component.name
      })
    }
  }
}
</script>
<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 10px;
}
</style>
